import React from 'react'
import { hooks } from '@front/volcanion'

import { Loader } from '@front/squirtle'

const withContainer = Component => props => {
  const isReady = hooks.useFormStatus('isReady')

  return (
    <Loader isLoading={!isReady}>
      <Component />
    </Loader>
  )
}

export default withContainer
